import React from 'react'

import { Alert, Typography, Box, Button, useTokens } from '@barracuda-internal/bds-core-v2'
import routesConfig from 'lib/routesConfig'

export interface ErrorProps {
  errorMessage: string
  expired: boolean
  onClick: () => void
}

const Error: React.FC<ErrorProps> = ({ errorMessage, expired, onClick }) => {
  const tokens = useTokens()

  return (
    <Box
      alignItems="center"
      display="flex"
      flexDirection="column"
      gap={tokens.aliasesSpaceContainerSpacious}
      padding={tokens.aliasesSpaceContainerSpacious}
    >
      <Box>
        <Alert bdsType="neutralError" bdsBoxShadowType="inline">
          <Typography variant="body1" align="left">
            {errorMessage}
          </Typography>
        </Alert>
      </Box>
      {expired && (
        <Box>
          <Button bdsType="interactiveEmphasis" onClick={onClick}>
            Open Email Gateway Defense
          </Button>
        </Box>
      )}
    </Box>
  )
}

export default Error
